module.exports = __webpack_public_path__ + "static/media/galerija_2017 (7).02520a63.jpg";